// Mirrors LoginIdClassifier.kt/PhonePatterns.kt on the backend exactly, so the frontend never
// accepts (or rejects) something the real backend authority disagrees with. Deliberately
// duplicated rather than shared across the Kotlin/JS boundary, kept as its own small,
// independently-testable module.
const EMAIL_PATTERN = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/
const DOMESTIC_PHONE_PATTERN = /^0\d{9,10}$/
const E164_JP_PATTERN = /^\+81\d{9,10}$/

// Validates a new login-id value looks like an email or phone number before it's ever sent to
// the backend, catching a typo immediately rather than after a round-trip to the OTC-send or
// submit endpoints.
export function looksLikeEmailOrPhone (value) {
  if (!value) {
    return false
  }
  if (EMAIL_PATTERN.test(value)) {
    return true
  }
  const digitsOnly = value.replace(/-/g, '')
  return DOMESTIC_PHONE_PATTERN.test(digitsOnly) || E164_JP_PATTERN.test(value)
}
